/**
 * Search input value recoil
 */

// Recoil
import { atom } from 'recoil';

export const searchInputValueAtom = atom<string>({
  key: 'searchInputValueAtom',
  default: '',
});
